import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss']
})
export class LinkComponent implements OnInit {
  @Input('text') public text: string;
  @Input('class') public class: string;
  @Input('routerLink') public routerLink: string;

  constructor() { }

  ngOnInit() {
  }

}
